export const RECORD = 'RECORD';
export const PLAY = 'PLAY';
export const OFF = 'OFF';
